<script lang="ts">
	import GalleryIndicator from '$lib/galleryIndicator.svelte';
	import type { SbColor } from '../types';
	import { carousels } from '$lib/state/storyblok/carousel.svelte';
	import { fade } from 'svelte/transition';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			carousel_id: string;
			color: Extract<SbColor, 'stone-5' | 'brown-2'>;
			mobile_only: boolean;
		}>['content'];
	}

	let { content }: Props = $props();

	let embla = $derived(carousels[content.carousel_id]);
	let active = $state(0);

	function handleChange() {
		active = embla?.selectedScrollSnap() ?? 0;
	}

	$effect(() => {
		if (embla) {
			active = embla.selectedScrollSnap();
			embla.on('select', handleChange);
		}

		return () => {
			embla?.off('select', handleChange);
		};
	});
</script>

{#if embla}
	<div use:editable={content} transition:fade class:lg:hidden={content.mobile_only}>
		<GalleryIndicator
			count={embla.slideNodes().length}
			{active}
			color={content.color}
			onchange={(index) => embla?.scrollTo(index)}
		/>
	</div>
{/if}
